<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>mScope Default Settings</strong>
        </div>

        <div>
          <slot v-if="showReportTitle">
            Template Id - {{activeReport.id}}
          </slot>
          <div class="row mt-1">
            <div class="col">
              <b-card title="Card Title" no-body>
                <b-tabs v-model="wizardStep" @activate-tab="wizardTabClick" @input="tabIsShown" card>
                  <b-tab title="1. Calculation Settings" active>
                    <button id="btnNextCalcSetts" class="btn btn-primary pull-right mr-2"
                            @click="wizardNextStep(1, 'Step1')">
                      <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                    </button>
                    <form data-vv-scope="Step1">
                      <b-row style="vertical-align: middle;padding-bottom:5px;" class="pt-4">
                        <b-col lg="6">
                          <div class="form-group row">
                            <label>Vehicle Set</label>
                            <dx-select-box id="selVehicleSet" style="width: 100%;" :items="vehicleSets" value-expr="id"
                                           display-expr="title" :value.sync="activeReport.vehicleSet"
                                           v-validate="{required: true}"
                                           :isValid="HasError('Step1.Vehicle Set')"
                                           :validationError="GetError('Step1.Vehicle Set')"
                                           name="Vehicle Set">
                            </dx-select-box>
                          </div>
                        </b-col>
                        <b-col lg="6">
                          <div class="form-group row">
                            <label>Competitive Mapping Set</label>
                            <dx-select-box id="selCompSet" style="width: 100%;" :items="competitiveSets" value-expr="SetId"
                                           display-expr="Name" :value.sync="activeReport.competitiveMappingSetId"
                                           v-validate="{required: true}"
                                           :isValid="HasError('Step1.Competitive Mapping Set')"
                                           :validationError="GetError('Step1.Competitive Mapping Set')"
                                           name="Competitive Mapping Set">
                            </dx-select-box>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="pt-4">
                        <b-col lg="3">
                          <label>Zip Code</label>
                          <dx-text-box id="inpZipCode" :value.sync="activeReport.zipCode"
                                       v-validate="{required: true, digits: 5}"
                                       :isValid="HasError('Step1.Zip Code')"
                                       :validationError="GetError('Step1.Zip Code')"
                                       name="Zip Code"></dx-text-box>
                        </b-col>
                        <b-col lg="3">
                          <label>Credit Score</label>
                          <dx-text-box id="inpCreditScore" v-model="activeReport.creditScore"
                                       v-validate="{required: true, digits: 3}"
                                       :isValid="HasError('Step1.Credit Score')"
                                       :validationError="GetError('Step1.Credit Score')"
                                       name="Credit Score"></dx-text-box>
                        </b-col>
                        <b-col lg="3">
                          <label>
                            Customer Cash
                            <slot v-if="activeReport.cashType !== 0" class="input-group-text ml-1 p-0">
                              (% of MSRP)
                            </slot>
                          </label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <b-form-select id="selCustCashType" v-model="activeReport.cashType" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                              </b-form-select>
                            </div>
                            <dx-number-box id="inpCustomerCash" class="form-control" v-model="activeReport.cashDown"
                                           name="Customer Cash"
                                           v-validate="{required: true, min_value: 0, max_value:999999}"
                                           :min="0"
                                           :max="999999"
                                           :isValid="HasError('Step1.Customer Cash')"
                                           :validationError="GetError('Step1.Customer Cash')"></dx-number-box>
                          </div>
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanMode !== 1">
                          <label>Annual Mileage</label>
                          <dx-select-box id="annualMileagedd" :items="annualMileageOptions" value-expr="value"
                                         display-expr="text" :value.sync="activeReport.annualMileage"
                                         name="Annual Mileage"
                                         :wrapItemText="true"
                                         :accept-custom-value="true"
                                         @customItemCreating="customItemCreating($event)"
                                         v-validate="{required: true}"
                                         :isValid="HasError('Step1.Annual Mileage')"
                                         :validationError="GetError('Step1.Annual Mileage')">
                          </dx-select-box>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2 pt-4">
                        <b-col lg="3">
                          <label>Scan Mode</label>
                          <dx-select-box id="scanModedd" :items="scanModeOptions" value-expr="value" display-expr="text"
                                         :value.sync="activeReport.scanMode"
                                         name="Scan Mode"
                                         :onValueChanged="ScanModeChange" />
                        </b-col>
                        <b-col lg="3">
                          <label>Scan Type</label>
                          <dx-select-box id="scanTypedd" :items="scanTypeOptions" value-expr="value" display-expr="text"
                                         :value.sync="activeReport.scanType"
                                         name="Scan Type" />
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanType === 1">
                          <label>Base Value</label>
                          <b-form-radio-group id="radGroupAdjustType" v-model="activeReport.adjustmentType"
                                              style="padding-top:6px;" :options="[
                                          {text: 'MSRP',value: 0},
                                          {text: 'Invoice',value: 1},
                                          ]">
                          </b-form-radio-group>
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanType === 1">
                          <label>Adjustment Value</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <b-form-select v-model="activeReport.adjustmentValueType" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                              </b-form-select>
                            </div>
                            <dx-text-box id="inpAdjustValueSellPrice" class="form-control"
                                         v-model="activeReport.adjustmentValue"
                                         v-validate="{required: true, min_value: -999999, max_value:999999}"
                                         :isValid="HasError('Step1.Adjustment Value')"
                                         :validationError="GetError('Step1.Adjustment Value')"
                                         name="Adjustment Value"></dx-text-box>
                          </div>
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanType === 0">
                          <label>Desired Profit</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <b-form-select v-model="activeReport.adjustmentValueType" :options="[
                                           {text:'$', value:0},
                                           ]">
                              </b-form-select>
                            </div>
                            <dx-text-box id="inpDesiredProfit" class="form-control"
                                         v-model="activeReport.adjustmentValue"
                                         v-validate="{required: true, min_value: 0, max_value:999999}"
                                         :isValid="HasError('Step1.Desired Profit')"
                                         :validationError="GetError('Step1.Desired Profit')"
                                         name="Desired Profit"></dx-text-box>
                          </div>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step1')"
                            v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}` }}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="2. Tracked Lender Options">
                    <b-row>
                      <b-col md="12" class="mb-2">
                        <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button class="btn btn-primary pull-right" @click="wizardNextStep(2, 'Step2')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row>
                    <form data-vv-scope="Step2">
                      <b-row>
                        <b-col lg="6">
                          <b-card>
                            <div slot="header">
                              <strong>Tracked Lenders</strong>
                              <b-form-input id="inpCompLenderSearch" v-model="lenderSearch" class="ml-4 w-50"
                                            style="display:inline" placeholder="Type to Search" />
                            </div> 
                            <b-row style="height: 300px; overflow: auto">
                              <b-col lg="12">
                                <table aria-busy="false" aria-colcount="3"
                                       class="table b-table table-striped table-bordered table-sm">
                                  <thead class="thead-light">
                                    <tr>
                                      <th aria-colindex="1" style="position: sticky; top: 0; z-index:200;">
                                        Lender Name
                                      </th>
                                      <th aria-colindex="3" style="position: sticky; top: 0; z-index:200;">
                                        <button @click.prevent="selectAllTrackedLenders"
                                                class="btn btn-primary text-white btn-sm">
                                          <i title="Select/Unselect All Compared Lenders" class="fa fa-check-square"></i>
                                          {{ !activeReport.trackedLenders.length ? 'Select All' : 'Unselect All' }}
                                        </button>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-if="!availableLenders.length" class="b-table-empty-row">
                                      <td colspan="3">
                                        <div role="alert" aria-live="polite">
                                          <div class="text-center my-2">No lenders found.</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-for="l in filteredLenders" v-bind:key="l.Name">
                                      <td>
                                        {{ l.Name }}
                                      </td>
                                      <td>
                                        <c-switch :id="l.Name" v-model="l.Tracked" @change="updateTrackedLenders"
                                                  type="text" variant="primary" on="On" off="Off" :pill="true"  />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                        <b-col lg="6">
                          <b-card>
                            <div slot="header">
                              <strong>All Captive Lenders: </strong>
                              <c-switch id="compareCaptLendSw" v-model="activeReport.compareAllCaptives" type="text"
                                        variant="primary" on="On" off="Off" :pill="true" />
                              <strong>+ Optional Selections</strong>
                              <b-form-input class="ml-4" style="display:inline; visibility: hidden; width: 10px;" />
                            </div>                            
                            <b-row style="height: 300px; overflow: auto">
                              <b-col lg="12">
                                <table aria-busy="false" aria-colcount="3"
                                       class="table b-table table-striped table-bordered table-sm">
                                  <thead class="thead-light">
                                    <tr>
                                      <th aria-colindex="1" style="position: sticky; top: 0; z-index:200;">Lender Name</th>
                                      <th aria-colindex="3" style="position: sticky; top: 0; z-index:200;"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-if="!selectedTrackedLenders.length" class="b-table-empty-row">
                                      <td colspan="3">
                                        <div role="alert" aria-live="polite">
                                          <div class="text-center my-2">No additional tracked lenders selected.</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-for="(l, i) in selectedTrackedLenders">
                                      <td>
                                        {{ l.Name }}
                                      </td>
                                      <td>
                                        <c-switch v-model="l.Tracked" @change="updateTrackedLenders" type="text"
                                                  variant="primary" on="On" off="Off" :pill="true" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step2')"
                            v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}` }}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="3. Compared Lender Options">
                    <b-row>
                      <b-col md="12" class="mb-2">
                        <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button class="btn btn-primary pull-right" @click="wizardNextStep(3, 'Step3')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row>
                    <form data-vv-scope="Step3">
                      <b-row>
                        <b-col lg="6">
                          <b-card>
                            <div slot="header">
                              <strong>Compared Lenders</strong>
                              <b-form-input id="inpCompLenderSearch" v-model="lenderSearch" class="ml-4 w-50"
                                            style="display:inline" placeholder="Type to Search" />
                            </div>
                             
                            <b-row style="height: 300px; overflow: auto">
                              <b-col lg="12">
                                <table aria-busy="false" aria-colcount="3"
                                       class="table b-table table-striped table-bordered table-sm">
                                  <thead class="thead-light">
                                    <tr>
                                      <th aria-colindex="1" style="position: sticky; top: 0; z-index:200;">
                                        Lender Name
                                      </th>
                                      <th aria-colindex="3" style="position: sticky; top: 0; z-index:200;">
                                        <button @click.prevent="selectAllComparedLenders"
                                                class="btn btn-primary text-white btn-sm">
                                          <i title="Select/Unselect All Compared Lenders" class="fa fa-check-square"></i>
                                          {{ !activeReport.comparedLenders.length ? 'Select All' : 'Unselect All' }}
                                        </button>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-if="!availableLenders.length" class="b-table-empty-row">
                                      <td colspan="3">
                                        <div role="alert" aria-live="polite">
                                          <div class="text-center my-2">No lenders found.</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-for="l in filteredLenders" v-bind:key="l.Name">
                                      <td>
                                        {{ l.Name }}
                                      </td>
                                      <td>
                                        <c-switch :id="l.Name" v-model="l.Compared" @change="updateComparedLenders"
                                                  type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                        <b-col lg="6">
                          <b-card>
                            <div slot="header">
                              <strong>All Captive Lenders: </strong>
                              <c-switch id="trackCaptLendSw" v-model="activeReport.trackAllCaptives" type="text"
                                        variant="primary" on="On"
                                        off="Off" :pill="true" />
                              <strong>+ Optional Selections</strong>
                              <b-form-input class="ml-4" style="display:inline; visibility: hidden; width: 10px;" />
                            </div>

                            <b-row style="height: 300px; overflow: auto">
                              <b-col lg="12">
                                <table aria-busy="false" aria-colcount="3"
                                       class="table b-table table-striped table-bordered table-sm">
                                  <thead class="thead-light">
                                    <tr>
                                      <th aria-colindex="1" style="position: sticky; top: 0; z-index:200;">Lender Name</th>
                                      <th aria-colindex="3" style="position: sticky; top: 0; z-index:200;"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-if="!selectedComparedLenders.length" class="b-table-empty-row">
                                      <td colspan="3">
                                        <div role="alert" aria-live="polite">
                                          <div class="text-center my-2">No compared lenders selected.</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-for="(l) in selectedComparedLenders" v-bind:key="l.Name">
                                      <td>
                                        {{ l.Name }}
                                      </td>
                                      <td>
                                        <c-switch v-model="l.Compared" @change="updateComparedLenders" type="text"
                                                  variant="primary" on="On" off="Off" :pill="true" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step3')"
                            v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}` }}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="4. Rebate Options">
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button id="btnNextRebOptions" class="btn btn-primary pull-right"
                                @click="wizardNextStep(4, 'Step4')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row>
                    <b-alert variant="info" dismissed="false" class="w-30" :show="true">
                      Note: These are conditional rebates.
                    </b-alert>
                    <form data-vv-scope="Step4">
                      <b-row v-bind:class="{'disableRebates': !VehicleSetIsNew}">
                        <b-col md="3">
                          <b-form-group>
                            <b-form-checkbox-group stacked v-model="activeReport.rebateOptions" :plain="false">
                              <b-form-checkbox value="4">Loyalty</b-form-checkbox>
                              <b-form-checkbox value="5">Conquest</b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group>
                            <b-form-checkbox-group stacked v-model="activeReport.rebateOptions" :plain="false">
                              <b-form-checkbox value="2">College Graduate</b-form-checkbox>
                              <b-form-checkbox value="1">Military</b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step4')"
                            v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}` }}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="5. Target Acquisition Settings" lazy>
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button id="btnNextTargAcqSetts" class="btn btn-primary pull-right"
                                @click="wizardNextStep(5, 'Step5')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row>
                    <form data-vv-scope="Step5">
                      <div v-if="HasValue(activeReport) && HasValue(activeReport.tgtAcquisition)">
                        <b-alert variant="info" dismissed="false" class="text-center" :show="true"
                                 style="padding: 0px !important;">
                          <b-row>
                            <b-col v-bind:class="{'col-md-9': true, 'disableTA': !activeReport.useTargetAcquisition }"
                                   class="text-center">
                              <div class="my-2" style="float: left;">Target Payment = Compared Vehicle Payment (+/-) &nbsp;</div>
                              <div style="float:left; max-width:70px;">
                                <b-form-select v-model="activeReport.tgtAcquisition.spreadType" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                                </b-form-select>
                              </div>
                              <div style="float:left; max-width:120px;">
                                <dx-number-box class="form-control" v-model="activeReport.tgtAcquisition.spreadValue"
                                               name="Target Payment"
                                               :min="-99999"
                                               :max="99999" />
                              </div>
                              <div class="my-2 ml-2" style="float: left;">
                                <b-form-checkbox v-model="activeReport.tgtAcquisition.spreadFromComparedWeightedPayment">
                                  Weighted
                                  <i class="fa fa-info-circle ml-1" title="Random text that explains weighted."></i>
                                </b-form-checkbox>
                              </div>
                            </b-col>
                            <b-col v-bind:class="{'disableTA': activeReport.useAverageReport, 'col-md-3': true }"
                                   class="my-2">
                              <div style="float:right;">
                                Enabled:
                                <c-switch id="swEnabled" v-model="activeReport.useTargetAcquisition" class="mb-0"
                                          type="text" variant="primary" on="On" off="Off" :pill="true" />
                              </div>
                            </b-col>
                          </b-row>
                        </b-alert>
                        <b-row v-show="activeReport.useTargetAcquisition">
                          <b-col sm="6" class="text-center">
                            <h1 style="padding: 0px !important; margin: 0px !important;">Ratios When Lowering Payment</h1>
                            <canvas id="talowerchart" ref="talowerchartref" width="360" height="360">
                              Your browser is too
                              old!
                            </canvas>
                          </b-col>
                          <b-col sm="6" class="text-center">
                            <h1 style="padding: 0px !important; margin: 0px !important;">Ratios When Raising Payment</h1>
                            <canvas id="taraisechart" ref="taraisechartref" width="360" height="360">
                              Your browser is too
                              old!
                            </canvas>
                          </b-col>
                        </b-row>
                        <div class="row" style="" v-show="activeReport.useTargetAcquisition">
                          <b-col md="6">
                            <table class="table tgtTable">
                              <thead>
                                <tr>
                                  <th scope="col">#</th>
                                  <th scope="col"></th>
                                  <th scope="col">Lowering Payment Limits</th>
                                  <th scope="col"></th>
                                  <th scope="col" class="ratioColumn">Ratios</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zRebate.Color)">
                                  <th scope="row">1</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.lowerPayment.zRebate.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Max Rebate</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.lowerPayment.zRebate.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.lowerPayment.Rebate"
                                                 v-validate="{min_value:0, max_value:30000}"
                                                 :isValid="HasError('Step5.Max Rebate')"
                                                 :validationError="GetError('Step5.Max Rebate')"
                                                 name="Max Rebate" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.lowerPayment.zRebate.Enabled">
                                      {{activeReport.tgtAcquisition.lowerPayment.rebatePercentInRoll|numberToPercent}}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zResidual.Color)">
                                  <th scope="row">2</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.lowerPayment.zResidual.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Max Residual Adj.</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.lowerPayment.zResidual.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.lowerPayment.residualPct"
                                                 v-validate="{min_value:0, max_value:40}"
                                                 :isValid="HasError('Step5.Max Residual Adj')"
                                                 :validationError="GetError('Step5.Max Residual Adj')"
                                                 name="Max Residual Adj" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.lowerPayment.zResidual.Enabled">
                                      {{ activeReport.tgtAcquisition.lowerPayment.rvPercentInRoll|numberToPercent }}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zRate.Color)">
                                  <th scope="row">3</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.lowerPayment.zRate.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Min Rate</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.lowerPayment.zRate.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.lowerPayment.Rate"
                                                 v-validate="{min_value:0, max_value:25}"
                                                 :isValid="HasError('Step5.Max Rate')"
                                                 :validationError="GetError('Step5.Max Rate')"
                                                 name="Max Rate" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.lowerPayment.zRate.Enabled">
                                      {{ activeReport.tgtAcquisition.lowerPayment.ratePercentInRoll|numberToPercent }}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zAcquisition.Color)">
                                  <th scope="row">4</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.lowerPayment.zAcquisition.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Min Acq Fee</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.lowerPayment.zAcquisition.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.lowerPayment.AcquisitionFee"
                                                 v-validate="{min_value:0, max_value:2000}"
                                                 :isValid="HasError('Step5.Min Acq Fee')"
                                                 :validationError="GetError('Step5.Min Acq Fee')"
                                                 name="Min Acq Fee" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.lowerPayment.zAcquisition.Enabled">
                                      {{ activeReport.tgtAcquisition.lowerPayment.acquisitionFeePercentInRoll|numberToPercent}}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zIncentive.Color)">
                                  <th scope="row">5</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.lowerPayment.zIncentive.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Max Incentive</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.lowerPayment.zIncentive.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.lowerPayment.Incentive"
                                                 v-validate="{min_value:0, max_value:20000}"
                                                 :isValid="HasError('Step5.Max Incentive')"
                                                 :validationError="GetError('Step5.Max Incentive')"
                                                 name="Max Incentive" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.lowerPayment.zIncentive.Enabled">
                                      {{ activeReport.tgtAcquisition.lowerPayment.incentivePercentInRoll|numberToPercent }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-col>
                          <b-col md="6">
                            <table class="table tgtTable">
                              <thead>
                                <tr>
                                  <th scope="col">#</th>
                                  <th scope="col"></th>
                                  <th scope="col">Raising Payment Limits</th>
                                  <th scope="col"></th>
                                  <th scope="col" class="ratioColumn">Ratios</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zRebate.Color)">
                                  <th scope="row">1</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.higherPayment.zRebate.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Min Rebate</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.higherPayment.zRebate.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.higherPayment.Rebate"
                                                 v-validate="{min_value:0, max_value:10000}"
                                                 :isValid="HasError('Step5.Min Rebate')"
                                                 :validationError="GetError('Step5.Min Rebate')"
                                                 name="Min Rebate" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.higherPayment.zRebate.Enabled">
                                      {{activeReport.tgtAcquisition.higherPayment.rebatePercentInRoll|numberToPercent}}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zResidual.Color)">
                                  <th scope="row">2</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.higherPayment.zResidual.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Min Residual Value</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.higherPayment.zResidual.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.higherPayment.residualPct"
                                                 v-validate="{min_value:20, max_value:90}"
                                                 :isValid="HasError('Step5.Min Residual Value')"
                                                 :validationError="GetError('Step5.Min Residual Value')"
                                                 name="Min Residual Value" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.higherPayment.zResidual.Enabled">
                                      {{ activeReport.tgtAcquisition.higherPayment.rvPercentInRoll|numberToPercent }}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zRate.Color)">
                                  <th scope="row">3</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.higherPayment.zRate.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Max Rate</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.higherPayment.zRate.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.higherPayment.Rate"
                                                 v-validate="{min_value:0, max_value:25}"
                                                 :isValid="HasError('Step5.Max Rate')"
                                                 :validationError="GetError('Step5.Max Rate')"
                                                 name="Max Rate" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.higherPayment.zRate.Enabled">
                                      {{ activeReport.tgtAcquisition.higherPayment.ratePercentInRoll|numberToPercent }}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zAcquisition.Color)">
                                  <th scope="row">4</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.higherPayment.zAcquisition.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Max Acq Fee</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.higherPayment.zAcquisition.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.higherPayment.AcquisitionFee"
                                                 v-validate="{min_value:0, max_value:3000}"
                                                 :isValid="HasError('Step5.Max Acq Fee')"
                                                 :validationError="GetError('Step5.Max Acq Fee')"
                                                 name="Max Acq Fee" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.higherPayment.zAcquisition.Enabled">
                                      {{activeReport.tgtAcquisition.higherPayment.acquisitionFeePercentInRoll|numberToPercent}}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-bind:style="GetStyle(activeReport.tgtAcquisition.lowerPayment.zIncentive.Color)">
                                  <th scope="row">5</th>
                                  <td>
                                    <DxCheckBox :value.sync="activeReport.tgtAcquisition.higherPayment.zIncentive.Enabled" :onValueChanged="SlicesChanged" />
                                  </td>
                                  <td>Min Incentive</td>
                                  <td>
                                    <DxNumberBox :width="visual.targetAcquisition.DxNumberBoxWidth" v-if="activeReport.tgtAcquisition.higherPayment.zIncentive.Enabled"
                                                 :value.sync="activeReport.tgtAcquisition.higherPayment.Incentive"
                                                 v-validate="{min_value:0, max_value:10000}"
                                                 :isValid="HasError('Step5.Min Incentive')"
                                                 :validationError="GetError('Step5.Min Incentive')"
                                                 name="Min Incentive" />
                                  </td>
                                  <td class="ratioColumn">
                                    <span v-if="activeReport.tgtAcquisition.higherPayment.zIncentive.Enabled">
                                      {{ activeReport.tgtAcquisition.higherPayment.incentivePercentInRoll|numberToPercent }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-col>
                        </div>
                      </div>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step5')"
                            v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}` }}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="6. Report Settings">
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <b-col md="12" class="mb-4 p-0">
                          <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                            <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                          </button>
                        </b-col>
                      </b-col>
                    </b-row>
                    <form data-vv-scope="Step6">
                      <b-row v-if="activeReport.scanMode === 0" class="w-75">
                        <label>Lease Terms:</label>&nbsp;&nbsp;<a href="javascript:void(0)"
                                                                  @click="selectallLeaseTerms(true)">Select All</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallLeaseTerms(false)">Unselect All</a>
                        <b-form-group>
                          <b-form-checkbox-group v-model="activeReport.terms"
                                                 :checked="activeReport.terms"
                                                 :plain="false"
                                                 name="Terms"
                                                 v-validate="{required: true}"
                                                 :isValid="HasError('Step6.Terms')">
                            <b-form-checkbox v-for="t in leaseTerms" :value="t" v-bind:key="t" :id="t">
                              {{ t.toString() }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-row>
                      <b-row v-if="activeReport.scanMode === 1" class="w-75">
                        <label>Retail Terms:</label>&nbsp;&nbsp;<a href="javascript:void(0)"
                                                                   @click="selectallRetailTerms(true)">Select All</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallRetailTerms(false)">Unselect All</a>
                        <b-form-group>
                          <b-form-checkbox-group v-model="activeReport.terms"
                                                 :checked="activeReport.terms"
                                                 :plain="false"
                                                 name="Terms"
                                                 v-validate="{required: true}"
                                                 :isValid="HasError('Step6.Terms')">
                            <b-form-checkbox v-for="t in retailTerms" :value="t" v-bind:key="t" :id="t">
                              {{ t.toString() }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-row>
                      <label>Options:</label>

                      <label class="mt-2">Sort By:</label>
                      <b-row style="max-width:250px;">
                        <b-form-select id="sortByDropDown" v-model="activeReport.sortBy" :options="[

                                           {text:'Payment Value Index (PVI)', value:0},
                                           {text:'Weighted Payment Spread', value:1},
                                           {text:'Vehicle (Year, Make, Model, Trim)', value:2},
                                           ]">
                        </b-form-select>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step6')"
                            v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}` }}
                        <br />
                      </span>
                    </div>
                  </b-tab>                 
                </b-tabs>
              </b-card>
            </div>
          </div>
          <b-row class="mx-2">
            <b-col md="12">
              <button class="btn btn-primary" @click="saveReportTemplate">
                <i class="fa fa-save"></i> <strong class="text-white">Save</strong>
              </button>

              <button class="btn btn-danger text-white" @click="deleteReportTemplate">
                <i title="Delete" class="fa fa-trash-o fa-lg"></i> <strong>Delete</strong>
              </button>
            </b-col>
          </b-row>          
        </div>
      </b-card>
    </div>  
    <loading :show="boolLoading" :label="txtLoading"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'
import notify from 'devextreme/ui/notify'
import moment from 'moment'
import PChart from '../components/PChart.js'
import invert from 'invert-color'
// eslint-disable-next-line no-unused-vars
import {Validator} from 'vee-validate'

import {
  DxTextBox,
  DxSlider,
  DxNumberBox,
  DxLookup,
  DxSelectBox,
  DxSwitch,
  DxDropDownBox,
  DxDateBox,
  DxButton,
  DxCheckBox,
  DxList,
  DxTagBox
} from 'devextreme-vue'
import DxPopup, {DxToolbarItem} from 'devextreme-vue/popup'
import {confirm, alert} from 'devextreme/ui/dialog'

const handlers = {}

const customRange = {
  getMessage (field, args) {
    let arr = (args + '').split(',')
    if (arr.length === 2) {
      let min = parseFloat(arr[0])
      let max = parseFloat(arr[1])
      return `Value of the field ${field} should be between ${min} and ${max}`
    }
    return `Check validator for a field ${field}`
  },
  validate (value, args) {
    let arr = (args + '').split(',')
    if (arr.length === 2) {
      let v = parseFloat(value + '')
      let min = parseFloat(arr[0])
      let max = parseFloat(arr[1])
      // console.log(`value: ${JSON.stringify(v)} min: ${JSON.stringify(min)} max: ${JSON.stringify(max)}`)
      if (v >= min && v <= max) {
        return true
      }
    }
    return false
  }
}
Validator.extend('customRange', customRange)

export default {
  name: 'mScopeRunReport',
  components: {
    loading,
    DxTextBox,
    DxSlider,
    DxNumberBox,
    DxLookup,
    DxSelectBox,
    DxSwitch,
    DxDropDownBox,
    cSwitch,
    DxPopup,
    DxToolbarItem,
    DxDateBox,
    DxButton,
    DxCheckBox,
    DxList,
    DxTagBox
  },
  created () {
    const self = this
    self.loadVehicleSets()
    self.loadcompetitiveSets()
    self.loadLenders() // call self.createReportTemplate() in callback to get defaults
    self.wizardStep = 0
    self.initLoad = true
    self.changesSaved = true   
  },

  data () {
    const self = this 
    return {
      IsDragOver: false,
      showReportTitle: false,            
      errMsg: '',
      initLoad: true,
      displayingData: false,
      changesSaved: true,      
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      lenderSearch: '',
      wizardStep: 0,
      wizardStepToChange: 0, 
      IsAllSelection: false,
      searchValue: '',
      // wizardBackStepClicked: false,
      vehicleSets: [],
      competitiveSets: [],
      activeReport: {},
      reports: [],
      annualMileageOptions: [
        {text: '2,500', value: '2500'},
        {text: '5,000', value: '5000'},
        {text: '7,500', value: '7500'},
        {text: '10,000', value: '10000'},
        {text: '10,500', value: '10500'},
        {text: '12,000', value: '12000'},
        {text: '13,500', value: '13500'},
        {text: '15,000', value: '15000'},
        {text: '16,500', value: '16500'},
        {text: '18,000', value: '18000'},
        {text: '19,500', value: '19500'}
      ],
      showCustomMileage: false,
      scanModeOptions: [
        {text: 'Lease', value: 0},
        {text: 'Retail', value: 1}
      ],
      scanModeSelect: [
        {text: 'All', value: 'All'},
        {text: 'Lease', value: 'Lease'},
        {text: 'Retail', value: 'Retail'}
      ],
      scanMode: 'All',
      scanTypeOptions: [
        {text: 'Profit', value: 0},
        {text: 'Selling Price', value: 1}
      ], 
      blankReport: {
        id: -1,
        title: '',
        vehicleSet: -1,
        zipCode: null,
        creditScore: '720',
        cashDown: null,
        annualMileage: '15000',
        cashType: 0,
        scanMode: 0,
        scanType: 1,
        sortBy: 1,
        groupBy: 0,
        adjustmentType: 0,
        adjustmentValueType: 0,
        adjustmentValue: null,
        outputType: [1, 2, 3],
        includeOnlyTermsWithTrackedLenderPresent: false,
        useAverageReport: false,
        trackAllCaptives: true,
        compareAllCaptives: true,
        terms: [],
        trackedLenders: [],
        comparedLenders: [],
        rebateOptions: [],
        useTargetAcquisition: true,
        targetAcquisition: {
          lower: [
            {
              id: 0,
              name: 'Max Rebate',
              enabled: true,
              val: 0,
              minimum: 0,
              proration: 20,
              maximum: 100,
              color: '#ffd8ad'
            },
            {
              id: 1,
              name: 'Max Residual',
              enabled: true,
              val: 0,
              minimum: 0,
              proration: 20,
              maximum: 100,
              color: '#b5f567'
            },
            {id: 2, name: 'Min Rate', enabled: true, val: 0, minimum: 0, proration: 20, maximum: 100, color: '#adeaff'},
            {
              id: 3,
              name: 'Min Acq Fee',
              enabled: true,
              val: 0,
              minimum: 0,
              proration: 20,
              maximum: 100,
              color: '#6970ff'
            },
            {
              id: 4,
              name: 'Max Incentive',
              enabled: true,
              val: 0,
              minimum: 0,
              proration: 20,
              maximum: 100,
              color: '#3a9fd6'
            }
          ],
          raise: [
            {
              id: 0,
              name: 'Min Rebate',
              enabled: true,
              val: 0,
              minimum: 0,
              proration: 20,
              maximum: 100,
              color: '#ffd8ad'
            },
            {
              id: 1,
              name: 'Min Residual',
              enabled: true,
              val: 0,
              minimum: 0,
              proration: 20,
              maximum: 100,
              color: '#b5f567'
            },
            {id: 2, name: 'Max Rate', enabled: true, val: 0, minimum: 0, proration: 20, maximum: 100, color: '#adeaff'},
            {
              id: 3,
              name: 'Max Acq Fee',
              enabled: true,
              val: 0,
              minimum: 0,
              proration: 20,
              maximum: 100,
              color: '#6970ff'
            },
            {
              id: 4,
              name: 'Min Incentive',
              enabled: true,
              val: 0,
              minimum: 0,
              proration: 20,
              maximum: 100,
              color: '#3a9fd6'
            }
          ]
        },
        tgtAcquisition: {
          version: 1,
          spreadType: 0,
          spreadValue: 0,
          spreadFromComparedWeightedPayment: false,
          decimalPlaces: 2,
          lowerPayment: {
            moneyFactor: 0,
            interestRate: 0,
            residualPct: 0,
            Rebate: 0,
            Incentive: 0,
            AcquisitionFee: 0,

            Rate: 0,

            rvPercentInRoll: 0,
            ratePercentInRoll: 0,
            rebatePercentInRoll: 0,
            incentivePercentInRoll: 0,
            acquisitionFeePercentInRoll: 0,

            zRebate: {
              Enabled: true,
              Percent: 20,
              Color: '#ffd8ad',
              MagicNameInRoll: 'rebatePercentInRoll',
              MagicNameReal: 'zRebate'
            },
            zIncentive: {
              Enabled: true,
              Percent: 20,
              Color: '#3a9fd6',
              MagicNameInRoll: 'incentivePercentInRoll',
              MagicNameReal: 'zIncentive'
            },
            zAcquisition: {
              Enabled: true,
              Percent: 20,
              Color: '#6970ff',
              MagicNameInRoll: 'acquisitionFeePercentInRoll',
              MagicNameReal: 'zAcquisition'
            },
            zResidual: {
              Enabled: true,
              Percent: 20,
              Color: '#b5f567',
              MagicNameInRoll: 'rvPercentInRoll',
              MagicNameReal: 'zResidual'
            },
            zRate: {
              Enabled: true,
              Percent: 20,
              Color: '#adeaff',
              MagicNameInRoll: 'ratePercentInRoll',
              MagicNameReal: 'zRate'
            }
          },
          higherPayment: {
            moneyFactor: 0,
            interestRate: 0,
            residualPct: 20,
            Rebate: 0,
            Incentive: 0,
            AcquisitionFee: 0,

            Rate: 0,

            rvPercentInRoll: 0,
            ratePercentInRoll: 0,
            rebatePercentInRoll: 0,
            incentivePercentInRoll: 0,
            acquisitionFeePercentInRoll: 0,

            zRebate: {
              Enabled: true,
              Percent: 20,
              Color: '#ffd8ad',
              MagicNameInRoll: 'rebatePercentInRoll',
              MagicNameReal: 'zRebate'
            },
            zIncentive: {
              Enabled: true,
              Percent: 20,
              Color: '#3a9fd6',
              MagicNameInRoll: 'incentivePercentInRoll',
              MagicNameReal: 'zIncentive'
            },
            zAcquisition: {
              Enabled: true,
              Percent: 20,
              Color: '#6970ff',
              MagicNameInRoll: 'acquisitionFeePercentInRoll',
              MagicNameReal: 'zAcquisition'
            },
            zResidual: {
              Enabled: true,
              Percent: 20,
              Color: '#b5f567',
              MagicNameInRoll: 'rvPercentInRoll',
              MagicNameReal: 'zResidual'
            },
            zRate: {
              Enabled: true,
              Percent: 20,
              Color: '#adeaff',
              MagicNameInRoll: 'ratePercentInRoll',
              MagicNameReal: 'zRate'
            }
          }
        }
      },
      taLowerChart: {
        minSlices: 2,
        maxSlices: 10,
        stepSlices: 1,
        slices: [],
        radius: 150,
        innerRadius: 0,
        canvas: undefined,
        PChart: undefined
      },
      taRaiseChart: {
        minSlices: 2,
        maxSlices: 10,
        stepSlices: 1,
        slices: [],
        radius: 150,
        innerRadius: 0,
        canvas: undefined,
        PChart: undefined
      },
      accessAverageReportOnly: false,
      retailTerms: ['12', '18', '24', '30', '36', '42', '48', '54', '60', '63', '66', '72', '75', '78', '84', '88', '90', '96'],
      leaseTerms: ['12', '15', '18', '21', '24', '25', '26', '27', '28', '30', '31', '32', '33', '34', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '48', '49', '50', '51', '52', '54', '57', '60', '66', '72'],
      availableLenders: [],
      touchEvent: {
        start: 'touchstart',
        move: 'touchmove',
        end: 'touchend'
      },
      mouseEvent: {
        start: 'mousedown',
        move: 'mousemove',
        end: 'mouseup'
      },
      visual: {
        targetAcquisition: {
          DxNumberBoxWidth: '100px'
        }
      }
    }
  },
  filters: {
    numberToPercent: function (value, IsPercentSymbolNeeded = true) {
      let intValue = (value !== undefined && value !== null) ? parseInt(parseFloat(value) * 100) : 0
      if (IsPercentSymbolNeeded) {
        return `${intValue} %`
      } else {
        return intValue
      }
    }
  },
  methods: {
    HandleError (err) {
      console.log(JSON.stringify(err, Object.getOwnPropertyNames(err)))
    },
    HasValue (val) {
      return val !== undefined && val !== null
    },
      
    handleSubmit () {
      const self = this
      if (!self.$refs.form.checkValidity()) {
        return
      }

      self.saveReportTemplate()
    },    
    customItemCreating (data) {
      const self = this
      if (!data.text || isNaN(data.text)) {
        data.customItem = null
        return
      }

      let amOption = {text: data.text, value: data.text.replace(',', '')}
      self.annualMileageOptions.push(amOption)
      data.customItem = amOption
    },
    selectallLeaseTerms (SelectAll) {
      const self = this
      self.activeReport.terms.splice(0)
      if (SelectAll) {
        self.leaseTerms.forEach(function (i) {
          self.activeReport.terms.push(i)
        })
      }
    },
    selectallRetailTerms (SelectAll) {
      const self = this
      self.activeReport.terms.splice(0)
      if (SelectAll) {
        self.retailTerms.forEach(function (i) {
          self.activeReport.terms.push(i)
        })
      }
    },
    loadLenders () {
      const self = this
      axios.get('/api/mScope/getlenders')
        .then(response => {
          self.boolLoading = false
          self.availableLenders = response.data
          self.createReportTemplate()
        })
        .catch(error => {
          if (error.response.status === 403) {
            self.$router.push('/login')
          }

          self.boolLoading = false
          self.errMsg = 'There was an error getting data : ' + error
          self.showDismissibleAlert = true
        })
    },
    loadVehicleSets () {
      const self = this
      axios.get('/api/mScope/loadvehiclesets')
        .then(response => {
          self.boolLoading = false
          self.vehicleSets = response.data
        })
        .catch(error => {
          if (error.response.status === 403) {
            self.$router.push('/login')
          }

          self.boolLoading = false
          self.errMsg = 'There was an error getting data : ' + error
          self.showDismissibleAlert = true
        })
    },
    loadcompetitiveSets () {
      const self = this
      axios.get('/api/mScope/getcompetitivemappingsets')
        .then(response => {
          self.boolLoading = false
          self.competitiveSets = response.data
        })
        .catch(error => {
          if (error.response.status === 403) {
            self.$router.push('/login')
          }

          self.boolLoading = false
          self.errMsg = 'There was an error getting data : ' + error
          self.showDismissibleAlert = true
        })
    },    
    setComparedFromLender (targetlender) {
      const self = this
      const lender = self.availableLenders.find(lender => lender.Name.toLowerCase() === targetlender.Name.toLowerCase())
      if (lender) {
        lender.Compared = targetlender.Compared
      }
    },
    setTrackedFromLender (targetlender) {
      let self = this
      const lender = self.availableLenders.find(lender => lender.Name.toLowerCase() === targetlender.Name.toLowerCase())
      if (lender) {
        lender.Tracked = targetlender.Tracked
      }
    },
    ScanModeChange () {
      const self = this
      if (self.displayingData === false) {
        self.activeReport.terms = []
      }
    },
    async createReportTemplate () {
      const self = this
      self.initLoad = false
      self.wizardStep = 0 
      self.displayingData = true
      self.boolLoading = false
      self.activeReport = JSON.parse(JSON.stringify(self.blankReport))

      try {
        const response = await axios.get('/api/mScope/getdefaultsettings')
        if (response.data.id !== -1) {          
          let tempObj = JSON.parse(JSON.stringify(self.blankReport))
          self.activeReport = Object.assign(tempObj, response.data)
          self.activeReport.vehicleSet = parseInt(self.activeReport.vehicleSet) 
          if (self.accessAverageReportOnly) {
            self.activeReport.useAverageReport = true
            self.activeReport.useTargetAcquisition = false
          }
          self.activeReport.trackedLenders.forEach(lender => self.setTrackedFromLender(lender))
          self.activeReport.comparedLenders.forEach(lender => self.setComparedFromLender(lender))
        }
        self.$validator.reset()
        self.wizardStep = 0
        self.changesSaved = true 
      } catch (error) {
        if (error.response.status === 403) {
          self.$router.push('/login')
        }

        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
      }      
      self.displayingData = false
    },
    
    setLegacyTerms () {
      const self = this
      try {
        if (self.activeReport.leaseTerms.length > 0 && self.activeReport.terms.length === 0) {
          for (let i = 0; i < self.activeReport.leaseTerms.length; i++) {
            let term = self.activeReport.leaseTerms[i]
            self.activeReport.terms.push(term.toString())
          }
        }
      } catch (e) {
      }
      try {
        if (self.activeReport.retailTerms.length > 0 && self.activeReport.terms.length === 0) {
          for (let i = 0; i < self.activeReport.retailTerms.length; i++) {
            let term = self.activeReport.retailTerms[i]
            self.activeReport.terms.push(term.toString())
          }
        }
      } catch (e) {
      }
    },
    async saveReportTemplate () {
      const self = this 

      const isValid = await self.trueValidateAll()
      
      if (isValid) {
         
        self.updateComparedLenders()
        
        axios.post('/api/mScope/savedefaulttemplate', self.activeReport)
          .then(response => {
            self.boolLoading = false
            self.activeReport = response.data            
            self.changesSaved = true
            notify('Report has been saved', 'success', 3500)
            self.$refs.AddEditTemplate.hide()
          })
          .catch(error => {
            if (error.response.status === 403) {
              self.$router.push('/login')
            }
            self.boolLoading = false
            self.errMsg = 'There was an error getting data : ' + error
            self.showDismissibleAlert = true
          })
      } else {
        notify('Please fix validation errors first', 'warning', 5500)
      }
    },
    deleteReportTemplate () {
      const self = this
      let result = confirm('Are you sure?', 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          axios.post('/api/mScope/deletereporttemplate', self.activeReport)
            .then(response => {
              self.boolLoading = false
              notify('Report has been deleted', 'success', 3500)
              self.createReportTemplate()
              self.initLoad = true
            })
            .catch(error => {
              if (error.response.status === 403) {
                self.$router.push('/login')
              }

              self.boolLoading = false
              self.errMsg = 'There was an error getting data : ' + error
              self.showDismissibleAlert = true
            })
        }
      })
    },
    trueValidateAllSilent (resetNeeded) {
      let self = this
      if (resetNeeded === undefined || resetNeeded === null) {
        resetNeeded = true
      }
      let validations = []
      validations.push(self.$validator.validate('Title.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step1.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step2.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step3.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step4.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step5.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step6.*', undefined, {silent: true}))      

      return Promise.all(validations).then(results => {
        const retValue = results.every(r => r)

        if (resetNeeded === true) {
          self.$validator.reset('Title.*')
          self.$validator.reset('Step1.*')
          self.$validator.reset('Step2.*')
          self.$validator.reset('Step3.*')
          self.$validator.reset('Step4.*')
          self.$validator.reset('Step5.*')
          self.$validator.reset('Step6.*')          
        }
        return retValue
      })
    },
    async trueValidateAll () {
      let self = this
      let validations = []
      validations.push(self.$validator.validateAll('Title'))
      validations.push(self.$validator.validateAll('Step1'))
      validations.push(self.$validator.validateAll('Step2'))
      validations.push(self.$validator.validateAll('Step3'))
      validations.push(self.$validator.validateAll('Step4'))
      validations.push(self.$validator.validateAll('Step5'))
      validations.push(self.$validator.validateAll('Step6'))
      
      const results = await Promise.all(validations)
      return results.every(r => r)
    },    

    selectAllTrackedLenders (event) {
      const self = this
      const hasTrackedLenders = self.activeReport.trackedLenders.length > 0
      self.availableLenders.forEach(lender => {
        lender.Tracked = !hasTrackedLenders
      })
      self.updateTrackedLenders()
      self.changesSaved = false
    },
    updateTrackedLenders () {
      const self = this
      self.activeReport.trackedLenders = self.selectedTrackedLenders
    },
    selectAllComparedLenders (event) {
      const self = this
      const hasComparedLenders = self.activeReport.comparedLenders.length > 0
      self.availableLenders.forEach(lender => {
        lender.Compared = !hasComparedLenders
      })
      self.updateComparedLenders()
      self.changesSaved = false
    },

    updateComparedLenders () {
      const self = this
      self.activeReport.comparedLenders = self.selectedComparedLenders
    },

    wizardBackStep () {
      const self = this
      self.wizardStep = self.wizardStep - 1      
    },

    tabIsShown (tabIsShown) {
      const self = this
      self.Recalculate()
      if (parseInt(tabIsShown) === 4) {
        setTimeout(function () {
          self.CreateCharts(false)
          setTimeout(function () {
            self.CreateCharts()
          }, 1500)
        }, 100)
      }
    },
    ResizeWindowHandler () {
      const self = this
      // console.log('ResizeWindowHandler')
      if (self.HasValue(self.activeReport) && self.HasValue(self.activeReport.targetAcquisition) && self.activeReport.useTargetAcquisition === true) {
        // TODO:throttling
        self.CreateCharts(false)
      }
    },
    WheelWindowHandler () {
      const self = this
      // console.log('WheelWindowHandler')
      if (self.HasValue(self.activeReport) && self.HasValue(self.activeReport.targetAcquisition) && self.activeReport.useTargetAcquisition === true) {
        try {
          // TODO:throttling
          self.CreateCharts(false)
        } catch (err) {
          self.HandleError(err)
        }
      }
    },
    ScrollWindowHandler () {
      const self = this
      // console.log('ScrollWindowHandler')
      if (self.HasValue(self.activeReport) && self.HasValue(self.activeReport.targetAcquisition) && self.activeReport.useTargetAcquisition === true) {
        self.CreateCharts(false)
      }
    },
    async wizardTabClick (newTabIndex, prevTabIndex, evt) {
      const self = this

      newTabIndex = parseInt(newTabIndex)
      prevTabIndex = parseInt(prevTabIndex)

      if (self.wizardStepToChange !== newTabIndex) {
        evt.preventDefault()
      }
      // if (newTabIndex > prevTabIndex && newTabIndex !== prevTabIndex + 1) {
      //   evt.preventDefault()
      //   return false
      // }
      let validateTab = parseInt(parseInt(prevTabIndex) + 1)
      let validationTarget = 'Step' + validateTab      

      let isValid = await self.$validator.validateAll(validationTarget)
      if (isValid) {
        self.changesSaved = false
        self.wizardStepToChange = newTabIndex
        self.wizardStep = newTabIndex
      }
      return false
    },
    async wizardNextStep (tabID, validationTarget) {
      const self = this      
      const isValid = await self.$validator.validateAll(validationTarget)

      if (isValid === true) {
        self.changesSaved = false
        self.wizardStep = parseInt(tabID + '')
      }

      return undefined
    },
    ChangeUseAverageReport () {
      const self = this
      self.activeReport.useTargetAcquisition = false
    },
    GetError (param) {
      const self = this
      let err = self.validateErrors.first(param)
      if (err !== undefined) {
        return {message: err}
      }
      return undefined
    },
    HasError (param) {
      const self = this
      if (self.validateErrors !== undefined && self.validateErrors.first(param) !== undefined) {
        return false
      }
      return true
    },
    CreateCharts (useTimeout) {
      const self = this
      try {
        if (self.HasValue(useTimeout)) {
          useTimeout = useTimeout === true
        } else {
          useTimeout = true
        }

        self.UnbindCharts()

        self.taLowerChart.slices.splice(0)
        self.taRaiseChart.slices.splice(0)

        const lower = self.activeReport.tgtAcquisition.lowerPayment
        let amount = 0
        let summ = 0
        let arr = [lower.zRebate, lower.zResidual, lower.zRate, lower.zAcquisition, lower.zIncentive]

        for (let i = 0; i < arr.length; i++) {
          let current = arr[i]
          if (current.Enabled) {
            amount++
            summ = summ + current.Percent
          }
        }

        let each = parseInt(100 / amount)
        let first = 100 - each * (amount - 1)

        for (let i = 0, k = 0; i < arr.length; i++) {
          let current = arr[i]
          if (current.Enabled) {
            current.Percent = summ === 100 ? current.Percent : (k === 0 ? first : each)

            let title = ''
            switch (current.MagicNameReal) {
              case 'zRebate':
                title = 'Rebate'
                break
              case 'zResidual':
                title = 'Residual'
                break
              case 'zRate':
                title = 'Rate'
                break
              case 'zAcquisition':
                title = 'Acq Fee'
                break
              case 'zIncentive':
                title = 'Incentive'
                break
              default:
                title = ``
                break
            }
            self.taLowerChart.slices.push({
              id: k++,
              color: current.Color,
              percent: current.Percent,
              MagicNameInRoll: current.MagicNameInRoll,
              MagicNameReal: current.MagicNameReal,
              title: title
            })
          }
        }

        amount = 0
        summ = 0
        arr.splice(0)
        arr = [
          self.activeReport.tgtAcquisition.higherPayment.zRebate,
          self.activeReport.tgtAcquisition.higherPayment.zResidual,
          self.activeReport.tgtAcquisition.higherPayment.zRate,
          self.activeReport.tgtAcquisition.higherPayment.zAcquisition,
          self.activeReport.tgtAcquisition.higherPayment.zIncentive]

        for (let i = 0; i < arr.length; i++) {
          let current = arr[i]
          if (current.Enabled) {
            amount++
            summ = summ + current.Percent
          }
        }

        each = parseInt(100 / amount)
        first = 100 - each * (amount - 1)

        for (let i = 0, k = 0; i < arr.length; i++) {
          let current = arr[i]
          if (current.Enabled) {
            current.Percent = summ === 100 ? current.Percent : (k === 0 ? first : each)

            let title = ''
            switch (current.MagicNameReal) {
              case 'zRebate':
                title = 'Rebate'
                break
              case 'zResidual':
                title = 'Residual'
                break
              case 'zRate':
                title = 'Rate'
                break
              case 'zAcquisition':
                title = 'Acq Fee'
                break
              case 'zIncentive':
                title = 'Incentive'
                break
              default:
                title = ``
                break
            }

            self.taRaiseChart.slices.push({
              id: k++,
              color: current.Color,
              percent: current.Percent,
              MagicNameInRoll: current.MagicNameInRoll,
              MagicNameReal: current.MagicNameReal,
              title: title
            })
          }
        }

        self.taLowerChart.canvas = self.$refs.talowerchartref
        if (self.taLowerChart.canvas !== undefined && self.taLowerChart.canvas !== null) {
          self.taLowerChart.PChart = new PChart(self.taLowerChart.canvas, self.taLowerChart.radius, self.taLowerChart.innerRadius, self.taLowerChart.slices)
        }

        self.taRaiseChart.canvas = self.$refs.taraisechartref
        if (self.taRaiseChart.canvas !== undefined && self.taRaiseChart.canvas !== null) {
          self.taRaiseChart.PChart = new PChart(self.taRaiseChart.canvas, self.taRaiseChart.radius, self.taRaiseChart.innerRadius, self.taRaiseChart.slices)
        }

        if (useTimeout) {
          setTimeout(function () {
            self.$nextTick(function () {
              setTimeout(function () {
                // console.log('Binding from create')
                self.BindCharts()
                self.ReDraw()
              }, 100)
            })
          }, 100)
        } else {
          self.BindCharts()
          self.ReDraw()
        }
      } catch (err) {
        self.HandleError(err)
      }
    },
    TouchStart (chart, name) {
      return handlers[name] || (handlers[name] = (event) => {
        if (chart.PChart) {
          chart.PChart.TouchStart(event)
        }
      })
    },
    TouchEnd (chart, name) {
      return handlers[name] || (handlers[name] = () => {
        if (chart.PChart) {
          chart.PChart.TouchEnd()
        }
      })
    },
    TouchMove (chart, name) {
      return handlers[name] || (handlers[name] = (event) => {
        if (chart.PChart) {
          chart.PChart.TouchMove(event)
        }
      })
    },
    BindChart (chart, name) {
      const self = this
      if (chart.PChart) {
        // setTimeout(function () {
        let deviceEvent = (chart.PChart.IsTouchDevice() !== 0) ? self.touchEvent : self.mouseEvent
        chart.canvas.addEventListener(deviceEvent.start, self.TouchStart(chart, 'start-' + name), {passive: true})
        chart.canvas.addEventListener(deviceEvent.move, self.TouchMove(chart, 'move-' + name), {passive: true})
        document.addEventListener(deviceEvent.end, self.TouchEnd(chart, 'end-' + name), {passive: true})
        // }, 0)
      }
    },
    BindCharts () {
      const self = this
      self.BindChart(self.taLowerChart, 'lower')
      self.BindChart(self.taRaiseChart, 'raise')
    },
    UnbindChart (chart, name) {
      const self = this
      if (chart.PChart) {
        let deviceEvent = (chart.PChart.IsTouchDevice() !== 0) ? self.touchEvent : self.mouseEvent
        chart.canvas.removeEventListener(deviceEvent.start, self.TouchStart(chart, 'start-' + name))
        chart.canvas.removeEventListener(deviceEvent.move, self.TouchMove(chart, 'move-' + name))
        document.removeEventListener(deviceEvent.end, self.TouchEnd(chart, 'end-' + name))
        chart.PChart = undefined
      }
    },
    UnbindCharts () {
      const self = this
      self.UnbindChart(self.taLowerChart, 'lower')
      self.UnbindChart(self.taRaiseChart, 'raise')
    },
    ReDraw () {
      const self = this
      if (self.taLowerChart.PChart !== undefined) {
        self.taLowerChart.PChart.ReDraw()
      }
      if (self.taRaiseChart.PChart !== undefined) {
        self.taRaiseChart.PChart.ReDraw()
      }
    },
    Invert (color) {
      return invert(color, true)
    },
    GetStyle (c) {
      const self = this
      return {
        'background-color': c,
        color: self.Invert(c)
      }
    },
    HandleKeydown (e) {
      const self = this
      if (e.shiftKey && e.ctrlKey && e.code === 'KeyH') {
        switch (self.wizardStep) {
          case 0:
            if (self.HasValue(self.activeReport)) {
              if (self.vehicleSets.length > 0) {
                self.activeReport.vehicleSet = self.vehicleSets[0].id
              }
              if (self.competitiveSets.length > 0) {
                self.activeReport.competitiveMappingSetId = self.competitiveSets[0].SetId
              }
              self.activeReport.title = `Report_${parseInt(Math.random() * 100000)}`
              self.activeReport.zipCode = '93003'
              self.activeReport.creditScore = '720'
              self.activeReport.cashDown = 1000
              self.activeReport.annualMileage = '15000'
              self.activeReport.adjustmentValue = '0'
            }
            break
          default:
            break
        }
      }

      if (e.ctrlKey && e.shiftKey && e.altKey && e.key === 'H') {
        self.showReportTitle = true
      }
    },
    DebugMe () {
      const self = this
      if (self.HasValue(self.activeReport) && self.HasValue(self.activeReport.tgtAcquisition)) {
        const lowerArray = self.activeReport.tgtAcquisition.lowerPayment
        const raiseArray = self.activeReport.tgtAcquisition.higherPayment
        const obj = {
          spreadType: self.activeReport.tgtAcquisition.spreadType,
          spreadValue: self.activeReport.tgtAcquisition.spreadValue,
          spreadFromComparedWeightedPayment: self.activeReport.tgtAcquisition.spreadFromComparedWeightedPayment,
          decimalPlaces: self.activeReport.tgtAcquisition.decimalPlaces
        }
        console.log('others:')
        console.table(JSON.parse(JSON.stringify(obj)))
        console.log('lowerArray:')
        console.table(JSON.parse(JSON.stringify(lowerArray)))
        console.log('raiseArray:')
        console.table(JSON.parse(JSON.stringify(raiseArray)))
      }
    },

    SlicesChanged () {
      const self = this
      // console.log('create from SlicesChanged')
      self.CreateCharts(false)
    },
    Recalculate () {
      const self = this
      try {
        // take care of the default terms
        if (self.HasValue(self.activeReport) && self.HasValue(self.activeReport.terms) && self.activeReport.terms.length === 0) {
          if (self.IsActiveReportLease) {
            self.activeReport.terms.push(36)
          }
          if (self.IsActiveReportRetail) {
            self.activeReport.terms.push(60)
          }
        }
      } catch (err) {
        self.HandleError(err)
      }
      try {
        if (self.HasValue(self.activeReport) && self.HasValue(self.activeReport.tgtAcquisition)) {
          let hRateValue = self.activeReport.tgtAcquisition.higherPayment.Rate
          let lRateValue = self.activeReport.tgtAcquisition.lowerPayment.Rate
          if (self.IsActiveReportLease) { // lease
            if (hRateValue > 0.01) {
              self.activeReport.tgtAcquisition.higherPayment.interestRate = hRateValue
              self.activeReport.tgtAcquisition.higherPayment.moneyFactor = hRateValue / 24000
            } else {
              self.activeReport.tgtAcquisition.higherPayment.interestRate = hRateValue * 240000
              self.activeReport.tgtAcquisition.higherPayment.moneyFactor = hRateValue
            }

            if (lRateValue > 0.01) {
              self.activeReport.tgtAcquisition.lowerPayment.interestRate = lRateValue
              self.activeReport.tgtAcquisition.lowerPayment.moneyFactor = lRateValue / 24000
            } else {
              self.activeReport.tgtAcquisition.lowerPayment.interestRate = lRateValue * 240000
              self.activeReport.tgtAcquisition.lowerPayment.moneyFactor = lRateValue
            }
          }
          if (self.IsActiveReportRetail) { // retail
            self.activeReport.tgtAcquisition.higherPayment.interestRate = hRateValue
            self.activeReport.tgtAcquisition.higherPayment.moneyFactor = 0

            self.activeReport.tgtAcquisition.lowerPayment.interestRate = lRateValue
            self.activeReport.tgtAcquisition.lowerPayment.moneyFactor = 0
          }
        }
      } catch (err) {
        self.HandleError(err)
      }
    }
  },
  computed: {
    IsActiveReportLease () {
      const self = this
      if (self.HasValue(self.activeReport) && self.HasValue(self.activeReport.scanMode)) {
        return self.activeReport.scanMode === 0
      }
      return true // default value if report is blank
    },
    IsActiveReportRetail () {
      const self = this
      if (self.HasValue(self.activeReport) && self.HasValue(self.activeReport.scanMode)) {
        return self.activeReport.scanMode === 1
      }
      return false // default value if report is blank
    },
    VehicleSetIsNew () {
      const self = this
      if (self.activeReport.vehicleSet === undefined || self.activeReport.vehicleSet === null) {
        return true
      }
      let vehicleSet = self.vehicleSets.find(vs => vs.id === parseInt(self.activeReport.vehicleSet))
      if (vehicleSet === undefined) { return false }
      return vehicleSet.isnew
    },
    lenderCalcType () {
      const self = this
      if (self.activeReport.trackAllCaptives === true) {
        return self.activeReport.scanMode === 0 ? 2 : 3
      }
      if (self.activeReport.scanMode === 1) {
        return 3
      }

      let rtnValue = 0
      let hasMF = false
      let hasIR = false

      if (hasIR) {
        rtnValue = 3
      }
      if (hasMF) {
        rtnValue = 2
      }
      if (hasMF && hasIR) {
        rtnValue = 1
      }
      if (!hasMF && !hasIR) {
        rtnValue = 2
      }
      if (self.activeReport.trackedLender !== undefined &&
        self.activeReport.trackedLender !== null &&
        self.activeReport.trackedLender.Name === 'Ford Motor Credit') {
        rtnValue = 4
      }

      return rtnValue
    },
    selectedTrackedLenders () {
      const self = this
      return self.availableLenders.filter(f => {
        return f.Tracked
      })
    },
    selectedComparedLenders () {
      const self = this
      return self.availableLenders.filter(f => {
        return f.Compared
      })
    },
    filteredLenders () {
      const self = this
      return self.availableLenders.filter(item => {
        return item.Name.toLowerCase().indexOf(self.lenderSearch.toLowerCase()) > -1
      })
    }
  },
  watch: {
    'activeReport.scanMode': {
      handler: function (after, before) {
        const self = this
        // const b = parseInt(before || -1)
        const a = parseInt(after || -1)
        // console.log(`wizardStep ${b} -> ${a}`)
        if (a > -1) {
          self.Recalculate()
        }
      }
    },
    'taLowerChart.slices': {
      handler: function (after, before) {
        const self = this
        const arr = self.taLowerChart.slices
        for (let i = 0; i < arr.length; i++) {
          self.activeReport.tgtAcquisition.lowerPayment[arr[i].MagicNameInRoll] = parseFloat(arr[i].percent) / 100
          self.activeReport.tgtAcquisition.lowerPayment[arr[i].MagicNameReal]['Percent'] = arr[i].percent
        }
      },
      deep: true
    },
    'taRaiseChart.slices': {
      handler: function (after, before) {
        const self = this
        const arr = self.taRaiseChart.slices
        for (let i = 0; i < arr.length; i++) {
          self.activeReport.tgtAcquisition.higherPayment[arr[i].MagicNameInRoll] = parseFloat(arr[i].percent) / 100
          self.activeReport.tgtAcquisition.higherPayment[arr[i].MagicNameReal]['Percent'] = arr[i].percent
        }
      },
      deep: true
    },
    'activeReport.tgtAcquisition': {
      handler: function (after, before) {
        const self = this
        if (after !== undefined) {
          let arrAfterLower = [
            after.lowerPayment.zRebate,
            after.lowerPayment.zResidual,
            after.lowerPayment.zRate,
            after.lowerPayment.zAcquisition,
            after.lowerPayment.zIncentive]
          let arrAfterHigher = [
            after.higherPayment.zRebate,
            after.higherPayment.zResidual,
            after.higherPayment.zRate,
            after.higherPayment.zAcquisition,
            after.higherPayment.zIncentive]

          for (let i = 0; i < arrAfterLower.length; i++) {
            let current = arrAfterLower[i]
            if (current.Enabled === false) {
              self.activeReport.tgtAcquisition.lowerPayment[current.MagicNameInRoll] = 0
            }
          }
          for (let i = 0; i < arrAfterHigher.length; i++) {
            let current = arrAfterHigher[i]
            if (current.Enabled === false) {
              self.activeReport.tgtAcquisition.higherPayment[current.MagicNameInRoll] = 0
            }
          }
          self.Recalculate()
        }
      },
      deep: true
    },    
    showCustomMileage: function (val, oldVal) {
      const self = this
      let annValue = 0
      if (val !== true && val !== 'true') {
        annValue = parseInt(self.activeReport.annualMileage)
        switch (annValue) {
          case 2500:
            return
          case 7500:
            return
          case 10000:
            return
          case 12000:
            return
          case 15000:
            return
          default:
            if (annValue >= 15000) {
              self.activeReport.annualMileage = '15000'
            } else if (annValue >= 12000) {
              self.activeReport.annualMileage = '12000'
            } else if (annValue >= 10000) {
              self.activeReport.annualMileage = '10000'
            } else if (annValue >= 7500) {
              self.activeReport.annualMileage = '7500'
            } else {
              self.activeReport.annualMileage = '2500'
            }
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    const self = this
    if (!self.changesSaved) {
      let result = confirm('You have unsaved changes. Would you like to proceed and discard?', 'Warning')
      result.then((dialogResult) => {
        if (!dialogResult) {
          return next(false)
        } else {
          return next()
        }
      })
    } else {
      return next()
    }
  },

  mounted () {
    const self = this
    // boolLoading must be set to false on data() binding so that mount hooks the change
    self.boolLoading = false

    window.addEventListener('keydown', self.HandleKeydown, {passive: true})
    window.addEventListener('resize', self.ResizeWindowHandler, {passive: true})
    document.addEventListener('wheel', self.WheelWindowHandler, {passive: true})
    // document.addEventListener('scroll', self.ScrollWindowHandler, {passive: true})
  },
  beforeDestroy () {
    const self = this
    self.UnbindCharts()

    window.removeEventListener('keydown', self.HandleKeydown, {passive: true})
    window.removeEventListener('resize', self.ResizeWindowHandler, {passive: true})
    document.removeEventListener('wheel', self.WheelWindowHandler, {passive: true})
    // document.removeEventListener('scroll', self.ScrollWindowHandler, {passive: true})
  }
}
</script>

<style>

.ratioColumn {
  text-align: center;
  border-left: 1px solid black;
}

.tgtTable > tbody > tr > td {
  vertical-align: middle !important;
}
.tgtTable > tbody > tr > th {
  vertical-align: middle !important;
}
.TargetAcquisitionTable {
  margin: 0 auto !important;
}

.TargetAcquisitionRow {
  font-size: 18px !important;
}

.TargetAcquisitionColumn {
  padding: 2px !important;
}

.category.AllowedZone {
  background: darkgreen !important;
  opacity: 0.4 !important;
}

.category.NotAllowedZone {
  background: darkred !important;
  opacity: 0.4 !important;
}

.box {
  min-height: 20px;
  min-width: 20px;
}

.color-input {
  width: 150px;
  height: 30px;
}

.disabledTab {
  pointer-events: none;
}

.dx-overlay-content {
  min-width: initial !important;
}

.table-xtra-condensed > thead > tr > th,
.table-xtra-condensed > tbody > tr > th,
.table-xtra-condensed > tfoot > tr > th,
.table-xtra-condensed > thead > tr > td,
.table-xtra-condensed > tbody > tr > td,
.table-xtra-condensed > tfoot > tr > td {
  padding: 2px;
  text-align: center;
}

.dx-widget .dx-slider-handle {
  background-color: #34b9a7;
}

.dx-slider-bar {
  background: #4bc300;
}

.centerDiv {
  margin-left: auto;
  margin-right: auto;
}

.vcenter {
  margin-top: auto;
  margin-bottom: auto;
}

.disableTA {
  pointer-events: none;
  opacity: 0.2;
}

.disableRebates {
  pointer-events: none;
  opacity: 0.2;
}

.numbercenter {
  text-align: center;
}

.template_rows {
  display: flex;
  flex: 10;
  flex-flow: column;
  border: 1px solid lightgray;
  max-height: 700px;
  min-height: 300px;
  overflow-y: auto;
}

.report_row {
  display: flex;
  flex-flow: row;
  border-bottom: 1px solid lightgray;
  height: 50px;
  justify-content: center;
  align-items: center;
  padding-bottom: 5px;
  padding-top: 5px;
  transition: 0.3s;
}

.report_row_slim_header {
  display: flex;
  flex-flow: row;
  border-bottom: 1px solid lightgray;
  background-color: lightgray;
  height: 35px;
  justify-content: center;
  align-items: center;
  padding-bottom: 2px;
  padding-top: 2px;
  transition: 0.3s;
}

.report_row_slim {
  display: flex;
  flex-flow: row;
  border-bottom: 1px solid lightgray;
  height: 35px;
  justify-content: center;
  align-items: center;
  padding-bottom: 2px;
  padding-top: 2px;
  transition: 0.3s;
}

.report_row_hover {
  display: flex;
  flex-flow: row;
  border-bottom: 1px solid lightgray;
  height: 50px;
  justify-content: center;
  align-items: center;
  padding-bottom: 5px;
  padding-top: 5px;
  background-color: #f0f3f5;
  /*font-weight: bold;*/
}

.report_row:hover {
  display: flex;
  flex-flow: row;
  border-bottom: 1px solid lightgray;
  height: 50px;
  justify-content: center;
  align-items: center;
  padding-bottom: 5px;
  padding-top: 5px;
  background-color: #eae1e1;
  /*font-weight: bold;*/
}

.category {
  display: flex;
  flex-flow: row;
  border-bottom: 1px solid lightgray;
  height: 40px;
  justify-content: center;
  align-items: center;
  font-weight: 100;
  transition: 0.3s;
}

.category:hover {
  background-color: #ddd;
  opacity: 0.6;
}

.category_selected {
  background-color: #ddd;
  font-weight: bold;
}

.headerCategory {
  display: flex;
  flex-flow: row;
  border-bottom: 1px solid lightgray;
  /*height: 40px;*/
  justify-content: center;
  align-items: center;
  background-color: #f0f3f5;
}

.customCategory {
  display: flex;
  flex-flow: row;
  border-bottom: 1px solid lightgray;
  height: 40px;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
}

.customCategory:hover {
  background-color: #ddd;
  opacity: 0.6;
}

.categories {
  display: flex;
  flex: 2;
  flex-flow: column;
  width: 250px;
  max-height: 700px;
}

.category_action {
  display: flex;
  flex: 2;
  margin-right: 10px;
}

.category_title {
  display: flex;
  flex: 10;
  margin-left: 10px;
}

.report_id {
  display: flex;
  flex-flow: column;
  flex: 1;
  padding-left: 10px;
}

.report_template_name {
  display: flex;
  flex-flow: column;
  flex: 5;
  padding-left: 3px;
}

.report_user {
  display: flex;
  flex-flow: column;
  flex: 1;
  padding-left: 3px;
}

.report_category {
  display: flex;
  flex-flow: column;
  flex: 1;
  padding-left: 3px;
}
.report_is_active {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
.report_date {
  display: flex;
  flex-flow: column;
  flex: 2;
  padding-left: 3px;
}

.report_time {
  display: flex;
  flex-flow: column;
  flex: 1;
}

.report_xls {
  display: flex;
  flex-flow: column;
  flex: 1;
  padding-left: 3px;
}

.report_html {
  display: flex;
  flex-flow: column;
  flex: 1;
  padding-left: 3px;
}

.report_json {
  display: flex;
  flex-flow: column;
  flex: 1;
  padding-left: 3px;
}

.report_action {
  display: flex;
  flex-flow: column;
  flex: 1;
  padding-left: 3px;
}

#mTemplate > .modal-xl {
    max-width: 1240px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/mScopeDefaultSettings.vue